import React, { useState, useEffect } from 'react';
import Footer from './components/Footer/footer';
import './App.css';
import Contact from './components/Contact-Us/contact-us';
import Services from './components/our-services/our-services';
import Header from './components/Header/header';
import Gallery from './components/Gallery/gallery';
import ErrorBoundary from './components/ErrorBoundary';
import Home from './components/Home/home';
import About from './components/About/about';
import ScrollProgress from './components/ScrollProgress/ScrollProgress';
import BackToTop from './components/BackToTop/BackToTop';

function App() {
  const [darkMode, setDarkMode] = useState(() => {
    const saved = localStorage.getItem('darkMode');
    return saved === 'true';
  });

  useEffect(() => {
    document.body.classList.toggle('dark-mode', darkMode);
    localStorage.setItem('darkMode', darkMode);
  }, [darkMode]);

  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
  };

  return (
    <ErrorBoundary>
      <div className="App">
        <ScrollProgress />
        <a href="#main-content" className="skip-link">
          Skip to main content
        </a>
        <button 
          className="dark-mode-toggle" 
          onClick={toggleDarkMode}
          aria-label="Toggle dark mode"
        >
          {darkMode ? '☀️' : '🌙'}
        </button>
        <Header />
        <main id="main-content">
        <Home />
        <About />
        <Services></Services>
        <Gallery></Gallery>
        <Contact></Contact>
      </main>
      <Footer></Footer>
      <BackToTop />
      </div>
    </ErrorBoundary>
  );
}

export default App;
